module.exports = __webpack_public_path__ + "img/bilibili-winter-tree-1.bff9a60f.bff9a60f.png";